module.exports = __webpack_public_path__ + "img/slice_section1.8649e454.png";